import * as fromWardReducer from './ward.reducer';
import {createSelector} from '@ngrx/store';
import {AppState} from "../../../../index";

export const currentState = (state: AppState) => (state[fromWardReducer.wardsFeatureKey]);

export const selectAllWards = createSelector(currentState, fromWardReducer.selectAll);

export const selectWardsLoadingState = createSelector(currentState, fromWardReducer.getLoading);
